import { useCallback } from 'react'

import { useAuth } from '@enechain/auth-js'

export function useAccessToken(): {
  getAccessToken: () => Promise<string | void>
} {
  const { getToken } = useAuth()

  const getAccessToken = useCallback(async (): Promise<string> => {
    return getToken().catch(() => '')
  }, [getToken])

  return {
    getAccessToken,
  }
}
